import React, { useState } from "react";
import { Global } from "../helpers/Global";

export const CrearPlantillaTurno = () => {
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [color, setColor] = useState("#85C1E9");
  const [segmentos, setSegmentos] = useState([
    { hora_inicio: "", hora_fin: "" }
  ]);
  const [mensaje, setMensaje] = useState("");
  const [loading, setLoading] = useState(false);

  // Añadir un nuevo segmento
  const agregarSegmento = () => {
    setSegmentos([...segmentos, { hora_inicio: "", hora_fin: "" }]);
  };

  // Eliminar un segmento
  const eliminarSegmento = (index) => {
    if (segmentos.length === 1) return;
    setSegmentos(segmentos.filter((_, i) => i !== index));
  };

  // Cambiar hora de un segmento
  const handleSegmentoChange = (index, campo, valor) => {
    const nuevos = segmentos.map((s, i) =>
      i === index ? { ...s, [campo]: valor } : s
    );
    setSegmentos(nuevos);
  };

  // Enviar formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje("");
    // Validación mínima
    if (!nombre.trim() || segmentos.some(s => !s.hora_inicio || !s.hora_fin)) {
      setMensaje("Faltan campos obligatorios.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(Global.url + "turnos/plantillas", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          nombre,
          descripcion,
          color,
          segmentos
        }),
      });
      if (res.ok) {
        setMensaje("Plantilla creada correctamente.");
        setNombre("");
        setDescripcion("");
        setColor("#85C1E9");
        setSegmentos([{ hora_inicio: "", hora_fin: "" }]);
      } else {
        setMensaje("Error al crear plantilla.");
      }
    } catch (err) {
      setMensaje("Error de conexión.");
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 480, margin: "auto" }}>
      <h2>Crear plantilla de turno</h2>
      <form onSubmit={handleSubmit} className="formulario-plantilla">
        <label>
          Nombre del turno:<br />
          <input value={nombre} onChange={e => setNombre(e.target.value)} required />
        </label>
        <label>
          Descripción:<br />
          <input value={descripcion} onChange={e => setDescripcion(e.target.value)} />
        </label>
        <label>
          Color:<br />
          <input type="color" value={color} onChange={e => setColor(e.target.value)} style={{ width: 48, height: 30, border: "none" }} />
        </label>
        <div style={{ margin: "1em 0" }}>
          <b>Segmentos (horarios):</b>
          {segmentos.map((seg, i) => (
            <div key={i} style={{ marginBottom: 8, display: "flex", gap: 8, alignItems: "center" }}>
              <input
                type="time"
                value={seg.hora_inicio}
                onChange={e => handleSegmentoChange(i, "hora_inicio", e.target.value)}
                required
              />
              <span>a</span>
              <input
                type="time"
                value={seg.hora_fin}
                onChange={e => handleSegmentoChange(i, "hora_fin", e.target.value)}
                required
              />
              {segmentos.length > 1 && (
                <button type="button" onClick={() => eliminarSegmento(i)} style={{ marginLeft: 6 }}>
                  ❌
                </button>
              )}
            </div>
          ))}
          <button type="button" onClick={agregarSegmento} style={{ marginTop: 6 }}>+ Añadir segmento</button>
        </div>
        <button type="submit" disabled={loading}>{loading ? "Guardando..." : "Crear plantilla"}</button>
      </form>
      {mensaje && <p style={{ color: mensaje.startsWith("Plantilla creada") ? "green" : "red" }}>{mensaje}</p>}
    </div>
  );
};
